<template>
  <div class="startSysnodeDiv">
    <sc-field-group ref="scFieldGroup" :fieldGroupName="fieldGroupName" :fieldGroup="fieldGroup" :specific-component="specificComponent" />
  </div>
</template>

<script>
import ScFieldGroup from '../base/ScFieldGroup.vue';
import ScSysnodeForm from './ScSysnodeForm';

export default {
  name: 'sc-sysnode',
  components: {
    ScFieldGroup,
    ScSysnodeForm,
  },

  props: {
    fieldGroupName: {
      type: String,
      required: true,
    },
    fieldGroup: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      specificComponent: ScSysnodeForm,
    };
  },
  methods: {
    refresh() {
      this.$refs.scFieldGroup.refresh();
    },
    validate() {
      return this.$refs.scFieldGroup.validate();
    },
    invalidate() {
      this.$refs.scFieldGroup.invalidate();
    },
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/sysnode/ScSysnode.vue?071b3586